import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { closeChat } from '../../../services/chats';

interface IProps {
  chatId: number;
}
export const ThunkCloseChat = createAsyncThunk<boolean, IProps>(
  `${storeResources.CHATS}/closeChat`,
  ({ chatId }) => closeChat(chatId).then(res => res.data),
);
